import '../assets/NcUserStatusIcon-Dra7jf_o.css';
import h from "vue";
import d from "@nextcloud/axios";
import { generateOcsUrl as v } from "@nextcloud/router";
import { getCapabilities as f } from "@nextcloud/capabilities";
import { r as u, J as p, a as e, K as g } from "./_l10n-BZu8wI2q.mjs";
import { n as w } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const m = '<!-- This icon is part of Material UI Icons. Copyright 2020 Google Inc., Apache-2.0 License -->\n<svg viewBox="0 0 16 16" width="16" height="16" xmlns="http://www.w3.org/2000/svg">\n	<path fill="var(--color-success)" d="M4.8 11.2h6.4V4.8H4.8v6.4zM8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8z" />\n</svg>\n', l = '<!-- This icon is part of Material UI Icons. Copyright 2020 Google Inc., Apache-2.0 License -->\n<svg viewBox="0 0 16 16" width="16" height="16" xmlns="http://www.w3.org/2000/svg">\n	<path fill="none" d="M-4-4h24v24H-4z" />\n	<path fill="var(--color-warning)" d="M6.9.1C3 .6-.1 4-.1 8c0 4.4 3.6 8 8 8 4 0 7.4-3 8-6.9-1.2 1.3-2.9 2.1-4.7 2.1-3.5 0-6.4-2.9-6.4-6.4 0-1.9.8-3.6 2.1-4.7z" />\n</svg>\n', S = '<!-- This icon is part of Material UI Icons. Copyright 2020 Google Inc., Apache-2.0 License -->\n<svg viewBox="0 0 16 16" width="16" height="16" xmlns="http://www.w3.org/2000/svg">\n	<path fill="none" d="M-4-4h24v24H-4V-4z" />\n	<path fill="var(--color-error)" d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8z" />\n	<path fill="#fdffff" d="M5 6.5h6c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5H5c-.8 0-1.5-.7-1.5-1.5S4.2 6.5 5 6.5z" />\n</svg>\n', c = '<!-- This icon is part of Material UI Icons. Copyright 2020 Google Inc., Apache-2.0 License -->\n<svg viewBox="0 0 16 16" width="16" height="16" xmlns="http://www.w3.org/2000/svg">\n	<path fill="none" d="M-4-4h24v24H-4V-4z" />\n	<path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 3.2c2.7 0 4.8 2.1 4.8 4.8s-2.1 4.8-4.8 4.8S3.2 10.7 3.2 8 5.3 3.2 8 3.2z" />\n</svg>\n';
u(p);
/**
 * @copyright 2023 Christopher Ng <chrng8@gmail.com>
 *
 * @author Christopher Ng <chrng8@gmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const b = (t) => {
  switch (t) {
    case "away":
      return e("away");
    case "busy":
      return e("busy");
    case "dnd":
      return e("do not disturb");
    case "online":
      return e("online");
    case "invisible":
      return e("invisible");
    case "offline":
      return e("offline");
    default:
      return t;
  }
};
u(g);
const _ = {
  name: "NcUserStatusIcon",
  props: {
    /**
     * Set the user id to fetch the status
     */
    user: {
      type: String,
      default: null
    },
    /**
     * Set the status
     *
     * @type {'online' | 'away' | 'busy' | 'dnd' | 'invisible' | 'offline'}
     */
    status: {
      type: String,
      default: null,
      validator: (t) => [
        "online",
        "away",
        "busy",
        "dnd",
        "invisible",
        "offline"
      ].includes(t)
    },
    /**
     * Set the `aria-hidden` attribute
     *
     * @type {'true' | 'false'}
     */
    ariaHidden: {
      type: String,
      default: null,
      validator: (t) => [
        "true",
        "false"
      ].includes(t)
    }
  },
  data() {
    return {
      fetchedUserStatus: null
    };
  },
  computed: {
    activeStatus() {
      var t;
      return (t = this.status) != null ? t : this.fetchedUserStatus;
    },
    activeSvg() {
      var s;
      return (s = {
        online: m,
        away: l,
        busy: l,
        dnd: S,
        invisible: c,
        offline: c
      }[this.activeStatus]) != null ? s : null;
    },
    ariaLabel() {
      return this.ariaHidden === "true" ? null : e("User status: {status}", { status: b(this.activeStatus) });
    }
  },
  watch: {
    user: {
      immediate: !0,
      async handler(t, s) {
        var a, n, i, r;
        if (!t || !((n = (a = f()) == null ? void 0 : a.user_status) != null && n.enabled)) {
          this.fetchedUserStatus = null;
          return;
        }
        try {
          const { data: o } = await d.get(v("/apps/user_status/api/v1/statuses/{user}", { user: t }));
          this.fetchedUserStatus = (r = (i = o.ocs) == null ? void 0 : i.data) == null ? void 0 : r.status;
        } catch {
          this.fetchedUserStatus = null;
        }
      }
    }
  },
  mounted() {
    !this.user && !this.status && h.util.warn("[NcUserStatusIcon] The `user` or `status` prop should be set.");
  }
};
var y = function() {
  var s = this, a = s._self._c;
  return s.activeStatus ? a("span", { staticClass: "user-status-icon", class: {
    "user-status-icon--invisible": ["invisible", "offline"].includes(s.status)
  }, attrs: { role: "img", "aria-hidden": s.ariaHidden, "aria-label": s.ariaLabel }, domProps: { innerHTML: s._s(s.activeSvg) } }) : s._e();
}, U = [], I = /* @__PURE__ */ w(
  _,
  y,
  U,
  !1,
  null,
  "b17810e4",
  null,
  null
);
const T = I.exports;
export {
  T as N,
  b as g
};
